import Joi from 'joi'
import {emailValidation, inputStringValidation, inputPhoneValidation, inputNumberValidation} from 'validation'

export const createContactSchema = Joi.object({
  firstName: inputStringValidation.trim().required().messages({
    'string.empty': `First name cannot be an empty field`,
    'any.required': `First name is a required field`,
    'string.min': `First name should have a minimum length of 2`,
  }),
  lastName: inputStringValidation.required().messages({
    'string.empty': `Last name cannot be an empty field`,
    'any.required': `Last name is a required field`,
    'string.min': `Last name should have a minimum length of 2`,
  }),
  email: emailValidation.required(),
  phone: inputPhoneValidation.allow(''),
  allowPortalAccess: Joi.boolean(),
  company: Joi.object({
    name: inputStringValidation.allow('').label('company name'),
    url: inputStringValidation.allow('').label('company url'),
    address: {
      country: inputStringValidation.allow('').label('country'),
    },
  }),
  tags: Joi.array(),
  notes: Joi.array(),
})

export const contactDetailLeftSchema = Joi.object({
  firstName: inputStringValidation.required(),
  lastName: inputStringValidation.required(),
  title: inputStringValidation.allow('').optional(),
  fields: Joi.object().messages({
    'object.base': "field can't be empty must need to contain data.",
  }),
  address: Joi.object({
    country: inputStringValidation.allow('').optional().label('country'),
    locality: inputStringValidation.allow('').optional().label('locality'),
    streetAddress: inputStringValidation.allow('').optional().label('street address'),
    postalCode: Joi.string().allow(null, '').label('Postal code'),
  }).optional(),
})

export const contactDetailsRightSchema = Joi.object({
  phone: inputPhoneValidation.allow('', null),
  companyId: Joi.any().allow(''),
  company: Joi.object({
    url: inputStringValidation.allow(''),
  }),
  address: Joi.object({
    locality: inputStringValidation.allow(''),
  }),
  allowPortalAccess: Joi.boolean().default(false),
})

export const contactSegmentStep1Schema = Joi.object({
  name: Joi.string().trim().required().messages({
    'string.empty': `Name is not allowed to be empty`,
  }),
  isStatic: Joi.boolean(),
})

export const contactSegmentStep2Schema = Joi.object({
  ids: Joi.array().items(Joi.number().integer()),
  conditions: Joi.object({
    assigneeId: inputNumberValidation.allow('', null).label('Assignee'),
    tag: Joi.number().allow('', null).label('Tags'),
    company: Joi.number().allow('', null),
    country: Joi.string().allow('', null),
    isFavourite: Joi.string().allow('', null),
  }),
})
